module.exports = "/_next/static/images/section-for-renewable-energy-57beb70a78b93544c4043b123cb9878f.png.webp";